import { t } from 'state/intl/translations';

const getPointsLabel = (points: number) => t('crownsEarned', { points });

export default getPointsLabel;
